module.exports = __webpack_public_path__ + "img/logo.43e142ac.png";